import React from 'react';

const Toolbar = () => {
  return (
    <div className="toolbar">
      <div className="toolbar__swipe-indicator">← Keep Practicing</div>
      <div className="toolbar__swipe-indicator">Perfect →</div>
    </div>
  );
};

export default Toolbar;
